import { isPlatform } from "@ionic/react";

export const isAndroidVersion = isPlatform('android') && !isPlatform('mobileweb');

export const isIOSVersion = isPlatform('ios') && !isPlatform('mobileweb');

export const isWebVersion = isPlatform('mobileweb') || isPlatform('desktop');

export const isMobileVersion = (isPlatform('android') || isPlatform('ios')) && !isPlatform('mobileweb');

